<template>
    <el-form
        :model="form"
        :rules="rules"
        ref="personalForm"
        label-width="140px"
        size="mini">
        <!-- 用户id -->
        <el-form-item
            :label="$t('message.cdata.form1')">
            <el-input
                :value="form.user_id"
                class="center-personal-form-input"
                disabled>
            </el-input>
        </el-form-item>
        <!-- 登录名 -->
        <el-form-item
            :label="$t('message.cdata.form13')">
            <el-input
                :value="form.username"
                class="center-personal-form-input"
                disabled>
            </el-input>
        </el-form-item>
        <!-- 真实姓名 -->
        <el-form-item
            :label="$t('message.cdata.form14')"
            prop="truename">
            <el-input
                v-model="form.truename"
                class="center-personal-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 昵称 -->
        <el-form-item
            :label="$t('message.cdata.form15')"
            prop="nickname">
            <el-input
                v-model="form.nickname"
                class="center-personal-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 电子邮箱 -->
        <el-form-item
            :label="$t('message.cdata.form4')"
            prop="email">
            <el-popover
                placement="right-start"
                trigger="focus">
                <ul class="center-personal-email-tips">
                    <li>{{$t("public.emailTips")}}</li>
                </ul>
                <el-input 
                    type="textarea"
                    v-model="form.email"
                    slot="reference"
                    autosize
                    class="center-personal-form-input">
                </el-input>
            </el-popover>
        </el-form-item>
        <!-- 手机号码 -->
        <el-form-item
            :label="$t('message.cdata.form6')"
            prop="phone">
            <el-input
                v-model="form.phone"
                class="center-personal-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 传真号码 -->
        <el-form-item
            :label="$t('message.cdata.form8')"
            prop="fax">
            <el-input
                v-model="form.fax"
                class="center-personal-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 提交行 -->
        <el-form-item>
            <el-button
                type="primary"
                @click="submitModify(form)">
                <span>{{$t("public.submitBtn")}}</span>
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { email } from "@/utils/validate";

export default {
    data() {
        let validateEmail = (rule, value, callback) => {
            email(this, true, value, callback);
        };
        return {
            form: {
                id: "",
                user_id: "",
                username: "",
                truename: "",
                nickname: "",
                email: "",
                phone: "",
                fax: "",
            },
            rules: {
                truename: [
                    { required: true, message: this.$t("message.cdata.rule12"), trigger: 'blur' }
                ],
                nickname: [
                    { required: true, message: this.$t("message.cdata.rule13"), trigger: 'blur' }
                ],
                email: [
                    { required: true, validator: validateEmail, trigger: ['blur', 'change'] }
                ],
                phone: [
                    { required: true, message: this.$t("message.cdata.rule5"), trigger: 'blur' }
                ],
                fax: [
                    { required: true, message: this.$t("message.cdata.rule7"), trigger: 'blur' }
                ],
            }
        }
    },
    computed: mapState({
        user_data: state => state.user.user_data,
    }),
    methods: {
        ...mapActions([
            "handleModifyPersonal",
            "getPersonalData",
        ]),
        setForm(val){
            this.form = {
                id: val.id,
                user_id: val.user_id,
                username: val.username,
                truename: val.truename,
                nickname: val.nickname,
                email: val.email,
                phone: val.phone,
                fax: val.fax
            }
        },
        submitModify(form){
            this.$refs.personalForm.validate((valid) => {
                if (valid) {
                    this.handleModifyPersonal({
                        id: form.id,
                        user_id:  form.user_id,
                        username:  form.username,
                        truename:  form.truename,
                        nickname:  form.nickname,
                        email:  form.email,
                        mobile:  form.mobile,
                        fax:  form.fax
                    }).then((res) => {
                        if(res){
                            this.$message({
                                showClose: true,
                                message: this.$t("public.modifySucc"),
                                type: "success"
                            })
                            setTimeout(() => {
                                this.getPersonalData();
                            }, 1000);
                        }
                    })
                } else {
                    return false;
                }
            });
        }
    },
    created() {
        this.setForm(this.user_data);
    },
    watch: {
        user_data(val){
            this.setForm(val);
        }
    },
}
</script>

<style scoped>
.center-personal-form-input{
    width: 230px;
}
.center-personal-email-tips{
    list-style-type: circle;
    padding-left: 20px;
    color: #909399;
}
</style>
